const initMockedData = () => {

};

export default initMockedData;